import { makeStyles } from '@material-ui/core/styles';

import { DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    lockedButtons: {
      height: DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT,
      marginLeft: theme.spacing(-2), // we want the locked buttons to have same position as in the list view
      marginTop: theme.spacing(-2.5), // we want the locked buttons to have same position as in the list view
    },
  }),
  { name: 'DocumentScoreBlock' }
);
